import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hamburger",
  "use": "icon-hamburger-usage",
  "viewBox": "0 0 40 22",
  "content": "<symbol viewBox=\"0 0 40 22\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hamburger\">\r\n<rect width=\"40\" height=\"2\" fill=\"currentColor\" />\r\n<rect y=\"10\" width=\"40\" height=\"2\" fill=\"currentColor\" />\r\n<rect y=\"20\" width=\"25\" height=\"2\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol